import Translate from "../../../../modules/local/Translate";
import React from "react";
import {renderIf} from "../../../Shared";

export const renderEmptyHolderMember = (title = 'no data yet', description = 'no data is available now') => (
    <Translate>
      {(t) => (
          <div className="my-3 px-3 py-4 flex flex-col gap-1 flex-center border border-color-50 rounded-md">
            <span className="text-center font-semibold text-sm text-color-100 leading-snug tracking-wider">
                {t(title)}
            </span>
            {renderIf(
                description,
                <span className="text-center text-xs text-color-400 italic">
                  {t(description)}
              </span>
            )}
          </div>
      )}
    </Translate>
)